module.exports = __webpack_public_path__ + "static/media/Search Sanctions Kişi Adı.8d665dea.xlsx";